import { registerMutation, registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { PilotWhitelist, Waitlist } from '../beta-access.js';

export const checkWhitelistQuery = registerQuery({
  operationName: 'checkWhitelistQuery',
  type: () => Boolean,
  params: [{ name: 'email', type: () => String }],
  resolve: (email: string) => async () => {
    const whitelistCol = await getCollection(PilotWhitelist);
    const entry = await whitelistCol.findOne({ email: { $regex: new RegExp(`^${email}$`, 'i') } });
    return !!entry;
  },
});

export const joinWaitlistMutation = registerMutation({
  operationName: 'joinWaitlistMutation',
  type: () => Boolean,
  params: [{ name: 'email', type: () => String }],
  resolve: (email: string) => async () => {
    const waitlistCol = await getCollection(Waitlist);

    const existing = await waitlistCol.findOne({ email: { $regex: new RegExp(`^${email}$`, 'i') } });
    if (existing) return true;

    const waitlistDoc = new Waitlist({
      email: email.toLowerCase(),
      timestamp: new Date().toISOString(),
    });

    await waitlistCol.insertOne(waitlistDoc.toObject());
    return true;
  },
});
